import { useState } from 'react'
import Modal from '../Modal'
import Select from '../Select'
import TextAreaField from '../TextAreaField'
import {
  CreateNewPayoutCreditFacilityModel,
  CurrencyCodeString,
} from '../../redux/types'

interface Props {
  customerId: string
  visible: boolean
  onAddClick?: (facility: CreateNewPayoutCreditFacilityModel) => void
  onCancelClick?: () => void
}

const AddPayoutCreditFacilityModal = ({ customerId, visible, onAddClick, onCancelClick }: Props) => {
  const [currency, setCurrency] = useState<CurrencyCodeString>(CurrencyCodeString.sek)
  const [allowedOriginsText, setAllowedOriginsText] = useState('')

  const getCurrencyOptions = () => {
    return Object.keys(CurrencyCodeString).filter(v => isNaN(Number(v)))
      .map((value) => { return { name: value, value: value }})
  }

  const getAllowedOrigins = () => {
    return allowedOriginsText
      .split(/[\n,]/)
      .map(origin => origin.trim())
      .filter(origin => origin.length > 0)
  }

  const handleOnAdd = () => {
    onAddClick && onAddClick({
      customerId,
      currency,
      allowedOrigins: getAllowedOrigins()
    })
  }

  const handleOnClose = () => {
    onCancelClick && onCancelClick()
  }

  return (
    <Modal
      title='Create payout credit facility'
      show={visible}
      okButtonTitle='Create'
      cancelButtonTitle='Cancel'
      onHide={handleOnClose}
      onOkClick={handleOnAdd}
      onCancelClick={handleOnClose}
    >
      <Select
        id='currency'
        key='currency'
        label='Currency'
        options={getCurrencyOptions()}
        selectedValue={currency.toString()}
        onSelect={(value) => setCurrency(value as CurrencyCodeString)}
      />
      <TextAreaField
        id='allowedOrigins'
        value={allowedOriginsText}
        label='Allowed origins'
        rows={3}
        onChange={(event) => setAllowedOriginsText(event.target.value)}
        placeholder=''
      />
    </Modal>
  )
}

export default AddPayoutCreditFacilityModal
